import React, { forwardRef } from 'react';
import type { TIconElement } from '@src/models/props';
import { Icon, IIconProps } from '@src/atoms/Icon/Icon';
import { TooltipNew } from '@src/atoms/TooltipNew';

type TInputIconProps = Omit<IIconProps, 'name'> & {
  config: TIconElement;
};

/**
 * Компонент для отрисовки иконки в элементах ввода.
 * Вероятно нужно будет только в либе
 **/
export const InputIcon = forwardRef<SVGSVGElement, TInputIconProps>(({ config, ...props }, ref) => {
  if (typeof config === 'object' && config.tooltip) {
    return (
      <TooltipNew {...config.tooltip}>
        <Icon {...props} {...config} name={config.name} ref={ref} />
      </TooltipNew>
    );
  }
  if (typeof config === 'object') {
    return <Icon {...props} ref={ref} {...config} />;
  }
  return <Icon {...props} ref={ref} name={config} />;
});
